// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DatadogJs from "./Datadog.js";

function initDatadogCfg(prim0, prim1, prim2, prim3, prim4) {
  DatadogJs.init(prim0, prim1, prim2, prim3, prim4);
  
}

function startRecording(prim) {
  DatadogJs.startRecording();
  
}

function stopRecording(prim) {
  DatadogJs.stopRecording();
  
}

export {
  initDatadogCfg ,
  startRecording ,
  stopRecording ,
  
}
/* ./Datadog.js Not a pure module */
